<template>
    <div>
        <div class="buttom" :style="btnstyle">{{msg}}</div>
    </div>
</template>
<script>
export default {
    props:{
        msg:{
            type:String
        },
        btnstyle:{
            type:Object,
            default:()=>{
                return {width:"100px",height:"36px", lineHeight:"36px" }
            }
        }
    },
    data() {
        return {

        }
    }
}
</script>
<style scoped>
    .buttom {
        text-align: center;
        font-size: 16px;
        color: #fff;
        margin-left: 40px;
        margin-top: 10px;
        background: url("../../assets/img/btn-bg.png") no-repeat 100% 100%;
        cursor: pointer;
    }
</style>


// WEBPACK FOOTER //
// src/components/xiayan/home/home/buttommodule.vue